/* <click-pack-picker>: CLICK! pack radio cards (draft 2026-10-27) that drive Aurora's own <variant-picker> in the
 * same section. Aurora then updates price, URL (?variant=), the form's id input, sold-out state and media.
 * Fallback (no Aurora picker found): set the form's id input + URL ourselves. */
(function () {
  if (!window.customElements || customElements.get('click-pack-picker')) return;

  class ClickPackPicker extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var scope = this.closest('.shopify-section') || document;
      this.form = scope.querySelector('form[data-type="add-to-cart-form"]') || scope.querySelector('form[action*="/cart/add"]');
      this.idInput = this.form && this.form.querySelector('input[name="id"]');
      this.radios = Array.prototype.slice.call(this.querySelectorAll('.ck-pack__radio'));
      var self = this;
      this.radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) self.apply(r); }); });
      var a = scope.querySelector('variant-picker');
      if (a) a.setAttribute('inert', ''); // hidden by CSS; keep it out of tab order too
      this._poll = setInterval(this.syncFromForm.bind(this), 500);
      this.paint();
    }

    disconnectedCallback() { clearInterval(this._poll); this._init = false; }

    apply(r) {
      var scope = this.closest('.shopify-section') || document;
      var aurora = scope.querySelector('variant-picker'); // Aurora may re-render it
      var drove = false;
      if (aurora) {
        if (!aurora.hasAttribute('inert')) aurora.setAttribute('inert', '');
        var g = aurora.querySelector('[data-variant-picker-option-inputs]');
        if (g) {
          var inputs = g.querySelectorAll('input');
          for (var k = 0; k < inputs.length; k++) {
            if (inputs[k].value === r.value) {
              if (!inputs[k].checked) { inputs[k].checked = true; inputs[k].dispatchEvent(new Event('change', { bubbles: true })); }
              drove = true; break;
            }
          }
        }
      }
      if (!drove && this.idInput) {
        var id = r.dataset.variant;
        this.idInput.value = id;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
        try { var u = new URL(window.location.href); u.searchParams.set('variant', id); history.replaceState({}, '', u.toString()); } catch (e) {}
      }
      this.paint();
    }

    syncFromForm() { // keep cards in sync if the variant changes elsewhere (back/forward, Aurora re-render)
      if (!this.idInput) return;
      var id = String(this.idInput.value);
      if (!id || id === this._lastId) return;
      this._lastId = id;
      this.radios.forEach(function (r) { if (r.dataset.variant === id) r.checked = true; });
      this.paint();
    }

    paint() {
      this.radios.forEach(function (r) { r.closest('.ck-pack__card').classList.toggle('is-selected', r.checked); });
    }
  }

  customElements.define('click-pack-picker', ClickPackPicker);
})();
